// GitHub :shortcode: → emoji. MarkdownContent doesn't expand shortcodes, so PR
// bodies (renovate's :arrow_up:, gitmoji commit prefixes, …) render literally.
// This covers the gitmoji set plus the common gemoji that show up in our
// release notes; unknown shortcodes are left untouched.
const SHORTCODES: Record<string, string> = {
  art: '🎨',
  zap: '⚡️',
  fire: '🔥',
  bug: '🐛',
  ambulance: '🚑️',
  sparkles: '✨',
  memo: '📝',
  rocket: '🚀',
  lipstick: '💄',
  tada: '🎉',
  white_check_mark: '✅',
  lock: '🔒️',
  closed_lock_with_key: '🔐',
  bookmark: '🔖',
  rotating_light: '🚨',
  construction: '🚧',
  green_heart: '💚',
  arrow_down: '⬇️',
  arrow_up: '⬆️',
  pushpin: '📌',
  construction_worker: '👷',
  chart_with_upwards_trend: '📈',
  recycle: '♻️',
  heavy_plus_sign: '➕',
  heavy_minus_sign: '➖',
  wrench: '🔧',
  hammer: '🔨',
  globe_with_meridians: '🌐',
  pencil2: '✏️',
  poop: '💩',
  rewind: '⏪️',
  twisted_rightwards_arrows: '🔀',
  package: '📦️',
  alien: '👽️',
  truck: '🚚',
  page_facing_up: '📄',
  boom: '💥',
  bento: '🍱',
  wheelchair: '♿️',
  bulb: '💡',
  beers: '🍻',
  speech_balloon: '💬',
  card_file_box: '🗃️',
  loud_sound: '🔊',
  mute: '🔇',
  busts_in_silhouette: '👥',
  children_crossing: '🚸',
  building_construction: '🏗️',
  iphone: '📱',
  clown_face: '🤡',
  egg: '🥚',
  see_no_evil: '🙈',
  camera_flash: '📸',
  alembic: '⚗️',
  mag: '🔍️',
  label: '🏷️',
  seedling: '🌱',
  triangular_flag_on_post: '🚩',
  goal_net: '🥅',
  dizzy: '💫',
  wastebasket: '🗑️',
  passport_control: '🛂',
  adhesive_bandage: '🩹',
  monocle_face: '🧐',
  coffin: '⚰️',
  test_tube: '🧪',
  necktie: '👔',
  stethoscope: '🩺',
  bricks: '🧱',
  technologist: '🧑‍💻',
  money_with_wings: '💸',
  thread: '🧵',
  safety_vest: '🦺',
  warning: '⚠️',
  tent: '⛺',
  books: '📚',
};

const SHORTCODE_RE = /:([a-z0-9_+-]+):/g;

/** Replace GitHub emoji shortcodes with their emoji; unknown ones are kept. */
export function emojify(text: string): string {
  return text.replace(SHORTCODE_RE, (full, name: string) =>
    Object.prototype.hasOwnProperty.call(SHORTCODES, name)
      ? SHORTCODES[name]
      : full,
  );
}
